import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const Brainstorm = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17.5312 7.77734C20.4424 7.44598 19.2738 4.39895 17.227 4.5985C18.6478 3.2695 15.9591 1.34906 14.8563 2.78934C14.8541 1.34906 11.3861 1.56421 11.2935 3.2695C9.56477 2.6644 8.21279 4.01836 8.73759 5.25605C6.83563 5.25605 6.3557 6.71777 6.92179 7.62109L6.97247 7.62184L6.91469 7.62615C4.90983 8.12801 5.5907 10.5803 7.13726 10.5803C6.64236 12.2668 9.54383 12.5699 10.7501 10.9754C11.5393 12.5336 14.672 12.8725 14.672 10.5392C16.6383 11.4892 18.0542 9.46404 17.2533 7.77325L17.5312 7.77734Z"
          fill="url(#paint0_linear_3560_224)"
        />
        <path
          d="M10.6529 2.42695C9.88729 1.20737 7.47376 1.07 7.16039 2.35554C6.4059 1.25672 3.56778 2.35554 4.3008 4.13007C3.09111 3.29005 1.24957 6.00116 2.83206 6.81297C0.881257 6.67894 0.881335 10.0678 3.22338 9.98381C2.74682 11.677 4.98367 12.1599 6.16016 11.0235C6.15978 11.0157 6.15946 11.0078 6.15919 11C5.39963 10.7692 4.97314 9.98546 4.85527 9.2801C4.78102 8.83576 4.85035 8.35287 5.12033 7.93458C5.30592 7.64703 5.57317 7.41027 5.91545 7.24059C5.78926 6.74986 5.85215 6.21143 6.12965 5.74886C6.44765 5.21878 7.01139 4.8412 7.77948 4.71156C7.74516 4.08765 8.02963 3.49985 8.49983 3.09792C9.02286 2.65083 9.836 2.29014 10.6529 2.42695C10.6666 2.39549 10.6376 2.45722 10.6529 2.42695Z"
          fill="url(#paint1_linear_3560_224)"
        />
        <path
          d="M11.5781 12.8124C11.1671 12.6499 10.9272 12.5652 10.6266 12.2436C9.91054 12.8468 8.82178 12.9164 8.04136 12.8327C7.55911 12.781 7.07411 12.6024 6.74417 12.2435C6.7074 12.2035 6.67325 12.162 6.64175 12.1191L6.02124 14.9818H8.75566L7.34048 19.3713L13.8887 13.7825H10.6266L11.5781 12.8124Z"
          fill="url(#paint2_linear_3560_224)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_3560_224"
            x1="12.4756"
            y1="1.83545"
            x2="12.4756"
            y2="12.2168"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#089AD7" />
            <stop offset="1" stopColor="#006CD8" />
          </linearGradient>
          <linearGradient
            id="paint1_linear_3560_224"
            x1="6.02129"
            y1="1.47217"
            x2="6.02129"
            y2="11.576"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#089AD7" />
            <stop offset="1" stopColor="#006CD8" />
          </linearGradient>
          <linearGradient
            id="paint2_linear_3560_224"
            x1="9.95497"
            y1="11.7393"
            x2="9.95497"
            y2="19.3713"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#006CD8" />
            <stop offset="1" stopColor="#089AD7" />
          </linearGradient>
        </defs>
      </svg>
    )
  },
)

export default Brainstorm
